module.exports = __webpack_public_path__ + "img/dimensionsPP.e648090c.png";